import { ActionTree } from 'vuex'
import { WorkFileIdentificationState } from './types';
import { RootState } from '@/store/types';

export const actions: ActionTree<WorkFileIdentificationState, RootState> = {
}
